var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_111_904)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6563 23.9996H18.3421C17.4899 23.9996 16.7992 23.3089 16.7992 22.4568V11.1425C16.7992 10.2904 17.4899 9.59961 18.3421 9.59961H29.6563C30.5084 9.59961 31.1992 10.2904 31.1992 11.1425V22.4568C31.1992 23.3089 30.5084 23.9996 29.6563 23.9996Z",
    fill: "#F99750"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4587 38.3998H11.1444C10.2923 38.3998 9.60156 37.709 9.60156 36.8569V25.5426C9.60156 24.6905 10.2923 23.9998 11.1444 23.9998H22.4587C23.3108 23.9998 24.0016 24.6905 24.0016 25.5426V36.8569C24.0016 37.709 23.3108 38.3998 22.4587 38.3998Z",
    fill: "#15D8AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8579 38.3998H25.5437C24.6915 38.3998 24.0008 37.709 24.0008 36.8569V25.5426C24.0008 24.6905 24.6915 23.9998 25.5437 23.9998H36.8579C37.71 23.9998 38.4008 24.6905 38.4008 25.5426V36.8569C38.4008 37.709 37.71 38.3998 36.8579 38.3998Z",
    fill: "#F15959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8031 20.1137L25.2814 13.8097C25.071 13.2829 24.5687 12.9429 24.0012 12.9429C23.4337 12.9429 22.9314 13.2829 22.721 13.8097L20.1993 20.1137C20.0411 20.509 20.2334 20.958 20.6292 21.1162C21.025 21.2755 21.4735 21.0826 21.6317 20.6863L22.0548 19.6286H25.9476L26.3707 20.6863C26.4913 20.9881 26.7811 21.1714 27.0869 21.1714C27.1823 21.1714 27.2793 21.1539 27.3732 21.1162C27.7689 20.958 27.9613 20.509 27.8031 20.1137ZM22.672 18.0857L24.0012 14.763L25.3304 18.0857H22.672Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.292 30.3267C19.501 29.979 19.6286 29.5769 19.6286 29.1425C19.6286 27.8663 18.5905 26.8282 17.3143 26.8282H14.7429C14.317 26.8282 13.9714 27.1738 13.9714 27.5997V30.6854V34.7997C13.9714 35.2256 14.317 35.5711 14.7429 35.5711H17.8286C19.388 35.5711 20.6571 34.302 20.6571 32.7425C20.6571 31.719 20.1086 30.8233 19.292 30.3267ZM15.5143 28.3711H17.3143C17.7397 28.3711 18.0857 28.7172 18.0857 29.1425C18.0857 29.5679 17.7397 29.914 17.3143 29.914H15.5143V28.3711ZM17.8286 34.0282H15.5143V31.4568H17.3143H17.8286C18.5377 31.4568 19.1143 32.0334 19.1143 32.7425C19.1143 33.4517 18.5377 34.0282 17.8286 34.0282Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7143 35.5711C31.421 35.5711 31.1252 35.542 30.8294 35.4838C29.1258 35.1473 27.7582 33.7757 27.4258 32.0711C27.1711 30.7633 27.5036 29.4329 28.3378 28.4204C29.1721 27.4083 30.402 26.8278 31.7123 26.8278C32.4908 26.8278 33.2552 27.0352 33.9232 27.4269C34.3044 27.6504 34.5414 28.0723 34.5414 28.5268V29.142C34.5414 29.5679 34.1959 29.9135 33.77 29.9135C33.3441 29.9135 32.9986 29.5679 32.9986 29.142V28.679C32.6023 28.4766 32.1614 28.3706 31.7123 28.3706C30.8645 28.3706 30.0685 28.7463 29.5281 29.4017C28.9806 30.0667 28.7717 30.9099 28.9405 31.7758C29.1539 32.8722 30.0333 33.7536 31.1282 33.97C31.9117 34.1252 32.6921 33.9645 33.3285 33.5211C33.6775 33.2785 34.1587 33.3623 34.4027 33.7124C34.6463 34.062 34.561 34.5426 34.2114 34.7867C33.4712 35.3029 32.6073 35.5711 31.7143 35.5711Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_904",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5479C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDers);
export default __webpack_public_path__ + "static/media/ders.08f9de54e21b4f37da8b706c0d09488e.svg";
export { ForwardRef as ReactComponent };